module.exports = __webpack_public_path__ + "img/wzf_8.d8b5e0a7.png";